module.exports = __webpack_public_path__ + "static/data-model-1-d53cf357f54b7df4bc65dd8045ee13e2.png";